// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"Slider_sliderWrapper__w1IHu","slideImage":"Slider_slideImage__HgBB1","box":"Slider_box__WN+aE"};